import { z } from 'zod';

z.config({ jitless: true });
